// [2026-08-11] ADDED — shadcn Badge, with the variants this product actually needs.
//
// EVERY VARIANT CARRIES A DOT AS WELL AS A COLOUR, and callers are expected to render the STATE
// AS TEXT inside it. That is not decoration: theme.css records that this palette was validated for
// colour-vision deficiency, and the whole point of that work is undone if "healthy" and "critical"
// differ only by hue. A reviewer deciding whether to escalate a real candidate — or an operator
// deciding whether to page someone — must not be asked to read colour alone.

import { cva } from 'class-variance-authority'
import { cn } from '../../lib/utils.js'

const badgeVariants = cva(
  'inline-flex items-center gap-1.5 rounded-full border border-solid px-2.5 py-0.5 ' +
  'text-[11.5px] font-medium leading-5 whitespace-nowrap [font-family:inherit]',
  {
    variants: {
      variant: {
        // Colours come from theme.css tokens, not from shadcn's zinc defaults, so a badge here
        // matches the same state rendered by the older screens.
        healthy: 'border-[#c9e9c9] bg-[var(--good-bg)] text-[#0a6b0a]',
        degraded: 'border-[#f3e0b4] bg-[var(--warning-bg)] text-[#7a5405]',
        critical: 'border-[#f2cfcf] bg-[var(--critical-bg)] text-[#98292a]',
        serious: 'border-[#f8dccd] bg-[var(--serious-bg)] text-[#8a3d16]',
        idle: 'border-border bg-secondary text-muted-foreground',
        outline: 'border-border bg-transparent text-foreground',
      },
    },
    defaultVariants: { variant: 'idle' },
  },
)

const DOT = {
  healthy: 'var(--good)',
  degraded: 'var(--warning)',
  critical: 'var(--critical)',
  serious: 'var(--serious)',
  idle: 'var(--ink-muted)',
  outline: 'var(--ink-muted)',
}

function Badge({ className, variant = 'idle', dot = true, children, ...props }) {
  return (
    <span className={cn(badgeVariants({ variant }), className)} {...props}>
      {dot && (
        <span aria-hidden="true"
              style={{ width: 6, height: 6, borderRadius: 999, background: DOT[variant] || DOT.idle,
                       flexShrink: 0 }} />
      )}
      {children}
    </span>
  )
}

export { Badge, badgeVariants }
